<div *ngIf="!mostrarFormulario" class="row animated fadeInRight">
  <!-- *FORMULARIO -->
  <app-lfsa-card-v2
    [innTemplate]="enviarTemplateEdit" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>

  <ng-template #enviarTemplateEdit>
    <form [formGroup]="formulario" class="form-group" novalidate>
      <div class="row">
        <div *ngIf="!loading" class="form-group col-md-6">
          <!--          <app-lfsa-input [control]="formulario.get('cedula') | formControl" [id]="'cedula'"
                                    [label]="'Cedula*'"
                                    [mostrarImg]="false" [placeholder]="'cedula'" [rutaImagen]="" [type]="'text'"
                                    formControlName="cedula">
                    </app-lfsa-input>-->
          <label>Cuenta Contable* {{ '  ' + labelCuentaContableInfo ? labelCuentaContableInfo : '' }}</label>
          <button (click)="openModalCuentaContable()"
                  [disabled]="editableForm"
                  class="btn btn-primary btn-block"
          >
            <i class="fa fa-users"></i>
          </button>
        </div>
        <div *ngIf="!loading" class="form-group col-md-6">
         <!-- <app-lfsa-combo-box [comboBox]="cmbMotivoPedido"
                              [control]="formulario.get('idMotivoPedido') | formControl"
                              [idOpcion]="'id'" [id]="'idMotivoPedido'" [label]="'Motivo Pedido*'"
                              [opcion]="'descripcion'"
                              formControlName="idMotivoPedido">
          </app-lfsa-combo-box>-->

          <app-lfsa-select-opt-isp
            (update)="formulario.get('idMotivoPedido').setValue($event)"
            [mostrarImg]="false"
            [rutaImagen]="'periodoIcon'"
            formControlName="idMotivoPedido"
            [control]="formulario.get('idMotivoPedido')"
            [claseLabel]="'letrasDanger'"
            [opcion]="'descripcion'"
            [idOpcion]="'id'"
            [comboBox]="cmbMotivoPedido"
            [label]="'Motivo Pedido*'"
            [id]="'idMotivoPedido'"
            [clearContenido]=false>
          </app-lfsa-select-opt-isp>


        </div>
      </div>
      <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [botonRegresar]="false"
                                   [formularioValido]="formulario.invalid"
                                   [loading]="loading" [textBoton]="textBoton"  > <!--[tooltip]="'Ventana de Historial de Procesos ZTRA'"-->
      </app-lfsa-botones-formulario>

      <div class="row mt-3">
        <div class="col-md-12 ">
          <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" *ngIf="!loading"
                           [columnDefs]="columnDefs"
                           [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
                           [ngStyle]="diccionarioModulo.agGrid.style"
                           [paginationPageSize]="diccionarioModulo.agGrid.paginacion"
                           [pagination]="true" [rowData]="rowData"
                           [rowSelection]="rowSelection" class="{{diccionarioModulo.agGrid.class}}"
                           id="{{diccionarioModulo.agGrid.id}}">
          </ag-grid-angular>
        </div>
      </div>

    </form>
  </ng-template>
</div>

<app-lfsa-modal [innTemplate]="modalDetalle" [titulo]="'Editar Motivo'" [idButton]="'arbrirModalDetalle'"
                [idClose]="'cerrarModalDetalle'" [idOpen]="'idOpenModalDetalle'"></app-lfsa-modal>
<ng-template #modalDetalle>
  <section class="section">
    <div class="row">
      <div class="col-md-12 ">

<!--          <div class="container position-relative">-->
            <div class="row d-flex justify-content-center">
              <div class="col-md-8 col-lg-6 col-xl-5">
<!--                <div class="card">-->
                <form [formGroup]="formularioEditar" class="form-group" novalidate>
                  <div class="card-body ">
<!--                    <form method="post">-->
                      <div class="mb-3">
                        <app-lfsa-input [isReadOnly]="true"
                                        [mostrarImg]="false" [rutaImagen]=""
                                        [control]="formularioEditar.get('desCtaContable')"
                                        [placeholder]="'Ninguno'"
                                        formControlName="desCtaContable"
                                        [label]="'Cuenta contable'"
                                        [type]="'text'"
                                        [id]="'desCtaContable'"
                                        [claseLabel]="'letrasDefaultBold'">
                        </app-lfsa-input>
                      </div>
                      <div class="mb-3">
                        <app-lfsa-select-opt-isp  formControlName="idMotivoPedido"
                                                  (update)="formularioEditar.get('idMotivoPedido').setValue($event)"
                                                  [control]="formularioEditar.get('idMotivoPedido')"
                                                  [claseLabel]="'letrasDefaultBold'"
                                                  [opcion]="'descripcion'"
                                                  [idOpcion]="'id'"
                                                  [comboBox]="cmbMotivoPedido"
                                                  [label]="'Motivo*'"
                                                  [id]="'idMotivoPedido'">
                        </app-lfsa-select-opt-isp>
                      </div>
                      <div class="p-2">
                        <button class="btn btn-success d-block w-100" type="submit" (click)="ActualizaMotivoPedido()">Actualizar Motivo </button>
                      </div>
<!--                    </form>-->
                  </div>
                </form>
<!--                </div>-->
              </div>
            </div>
<!--          </div>-->

      </div>
    </div>
  </section>
</ng-template>

<app-modal-cuenta-contable></app-modal-cuenta-contable>
